import { isNonEmptyArray, isNonEmptyObject, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import {
	FORM_OUTCOME_COMPLETE,
	SELECT_ALL_KEY,
	IS_DEV
} from "globals/constants";
import {
	dateReadFormatter,
	formatDatesInObject,
	filterCertificationTasks,
	filterUserReviewTasks,
	assembleFormSectionsAndElements,
	notifyError,
} from "utils";
import { mapType } from "utils/forms";
import { api } from "services";
import store from '../store/store';


export const filterProposalReviewTasks = (proposal, userTasks) => {
	if (isNonEmptyObject(proposal) && isNonEmptyArray(userTasks)) {
		if (proposal.proposalId) {
			const userReviewTasks = filterUserReviewTasks(userTasks);

			return userReviewTasks
				.filter(({ submissionId, submissionType }) => submissionType === "proposal" && submissionId === proposal.proposalId);
		}
	}

	return [];
};

export const filterProposalCertificationTasks = (proposal, proposalTasks) => {
	const hasProposal = isNonEmptyObject(proposal);
	const hasTasks = isNonEmptyArray(proposalTasks);
	const hasProposalId = isNonEmptyString(proposal.proposalId);

	return hasProposal && hasTasks && hasProposalId
		? filterCertificationTasks(proposalTasks)
		: [];
};

export const onOutcomePressed = async (values, outcome, proposal) => {
	try {
		await api.tasks.saveTask(
			proposal?.formTaskId,
			{ values, outcome: outcome || FORM_OUTCOME_COMPLETE },
			{ numRetries: 0, notifyUponError: false },
		);

		window.dispatchEvent(new CustomEvent("form:outcomePressed", { detail: true }));

	} catch (error) {
		const message = IS_DEV ? error.message : store.getState().dictionary.proposals.routing.errors.routeReviewFailed;

		window.dispatchEvent(new CustomEvent("form:outcomePressed", { detail: false }));

		notifyError(message, error);
	}
};

export const getTotalProposals = ({ searchTerms }) => {
	return findProposals({
		pageLimit: 1,
		pageOffset: 0,
		searchTerms,
		fieldKeys: [ "proposalId" ]
	})
		.then(({ totalItems }) => {
			return totalItems;
		});
};

export const fetchProposal = async proposalId => {
	const proposal = await api.proposal.get(proposalId);

	const { formElements, formSections } = assembleFormSectionsAndElements(proposal.formElements, { mapType });

	return { ...proposal, formElements, formSections };
};

const normalizeProposalListData = data => {
	const mappedColumnValues = (data?.content || []).map(proposalFeedItem => {
		const hasColumnValues = isNonEmptyObject(proposalFeedItem.columnValues);

		if (!hasColumnValues) {
			return {};
		}

		return {
			...formatDatesInObject(proposalFeedItem.columnValues, dateReadFormatter),
			adminTeamMemberData: proposalFeedItem.adminTeamMembers
		};
	});

	return { items: mappedColumnValues, totalItems: data?.totalElements };
};

export const findProposals = async ({
	pageLimit: incomingPageLimit,
	pageOffset,
	searchTerms,
	fieldKeys
}) => {
	const pageLimit = incomingPageLimit === SELECT_ALL_KEY
		? await getTotalProposals({ searchTerms })
		: incomingPageLimit;

	if (pageLimit === 0) {
		return Promise.resolve({ items: [], totalItems: 0 });
	}

	const data = await api.proposal.getList({
		page: pageOffset,
		size: pageLimit,
		search: searchTerms,
		fields: fieldKeys,
	});

	return normalizeProposalListData(data);
};
